<template>
  <checkbox
    v-if="columnType === 'bool'"
    :value="localResource.data.attributes[attribute]"
    @update:data="(value) => update(attribute, value === 'true' || value === true ? 1 : 0)"
  ></checkbox>
  <input
    v-else
    :value="localResource.data.attributes[attribute]"
    :placeholder="trans(`models.${resource.meta.resourceType}.attributes.${attribute}`)"
    class="form-control"
    @change="update(attribute, $event.target.value)"
  />
</template>

<script>
import useModels from '@kanrisha/composables/useModels';
import { router } from '@inertiajs/vue3';
import { ref } from 'vue';
import Checkbox from '../Form/Checkbox';

export default {
  components: {
    Checkbox,
  },
  props: {
    attribute: { type: String, default: '' },
    columnType: { type: String, default: '' },
    options: { type: Object, default: () => {} },
    resource: { type: Object, default: () => {} },
  },
  setup(props) {
    const { storeModel } = useModels({ resourceType: props.resource.meta.resourceType });

    const localResource = ref(props.resource);
    localResource.value.data.attributes[props.options.relation?.relatedKey] = ref(
      props.options.parentResource?.data.id
    ).value;

    const update = async (attribute, value) => {
      localResource.value.data.attributes[attribute] = value;
      await storeModel(localResource.value, localResource.value.meta.resourceType, {
        parent: localResource.value.meta.relationInfo?.parentType,
        relation: localResource.value.meta.relationInfo?.name,
        related: localResource.value.meta.relationInfo?.relatedName,
      });
      router.reload();
    };

    return {
      localResource,
      update,
    };
  },
};
</script>

<style lang="scss">
.checkbox {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
  line-height: 1.1875rem;
  display: inline;

  input[type='checkbox'] + .check {
    width: 1.375rem;
    height: 1.375rem;
    min-width: 1.375rem;
    display: inline;
  }
}
</style>

<style lang="scss" scoped>
.form-control {
  border-radius: 0;
  margin-bottom: -0.625rem;
  margin-top: -0.25rem;
  line-height: 1.1875rem;
}
</style>
